var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement, html, css } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import '../text/PythonCodeDisplayer';
let PythonCodeInput = class PythonCodeInput extends LitElement {
    constructor() {
        super(...arguments);
        this.code = '';
    }
    onInput(e) {
        this.code = e.target.value;
        this.dispatchEvent(new CustomEvent('code-changed', { detail: this.code }));
    }
    onKeyDown(e) {
        const textarea = e.target;
        if (e.key === 'Tab') {
            e.preventDefault();
            const start = textarea.selectionStart;
            const end = textarea.selectionEnd;
            const value = textarea.value;
            // Insert tab or indent selection
            if (!e.shiftKey) {
                if (start !== end) {
                    // Indent selected lines
                    const before = value.substring(0, start);
                    const selected = value.substring(start, end);
                    const after = value.substring(end);
                    const indented = selected.replace(/(^|\n)/g, '$1  ');
                    textarea.value = before + indented + after;
                    this.code = textarea.value;
                    // Reselect the indented text
                    textarea.selectionStart = start;
                    textarea.selectionEnd = end + (indented.length - selected.length);
                }
                else {
                    // Insert two spaces at cursor
                    textarea.value = value.substring(0, start) + '  ' + value.substring(end);
                    this.code = textarea.value;
                    textarea.selectionStart = textarea.selectionEnd = start + 2;
                }
            }
            else {
                // Unindent selection
                if (start !== end) {
                    const before = value.substring(0, start);
                    const selected = value.substring(start, end);
                    const after = value.substring(end);
                    const unindented = selected.replace(/(^|\n)  /g, '$1');
                    textarea.value = before + unindented + after;
                    this.code = textarea.value;
                    textarea.selectionStart = start;
                    textarea.selectionEnd = end - (selected.length - unindented.length);
                }
            }
            this.dispatchEvent(new CustomEvent('code-changed', { detail: this.code }));
        }
    }
    render() {
        return html `
      <textarea
        .value=${this.code}
        @input=${this.onInput}
        @keydown=${this.onKeyDown}
        place
        spellcheck="false"
      ></textarea>
      <python-code-displayer .code=${this.code}></python-code-displayer>
    `;
    }
};
PythonCodeInput.styles = css `
    :host {
      display: block;
    }
    textarea {
      width: 100%;
      min-height: 120px;
      font-family: 'Fira Code', monospace;
      font-size: 1em;
      margin-bottom: 1em;
      box-sizing: border-box;
    }
  `;
__decorate([
    property({ type: String })
], PythonCodeInput.prototype, "code", void 0);
PythonCodeInput = __decorate([
    customElement('python-code-input')
], PythonCodeInput);
export { PythonCodeInput };
//# sourceMappingURL=PythonCodeInput.js.map